import axios from "axios";
import { buildGameStartPayload } from "./gameStartPayload";

export function getStoredUserId() {
  try {
    const stored = localStorage.getItem("user");
    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    return parsed?.id || parsed?.user?.id || parsed?.UserID || null;
  } catch {
    return null;
  }
}

export function isMobileGameLaunch() {
  if (typeof window === "undefined") {
    return false;
  }

  if (typeof window.matchMedia === "function") {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  return Number(window.innerWidth || 0) <= 768;
}

export function buildGameLaunchPayload({ game, selectedProvider }) {
  const productId = String(
    game?.productId ||
      game?.providerId ||
      selectedProvider?.productId ||
      selectedProvider?.game ||
      selectedProvider?.id ||
      "",
  ).trim();
  const gameCode = String(
    game?.gameCode || game?.gamecode || game?.code || game?.id || "",
  ).trim();

  return {
    id: getStoredUserId(),
    productId,
    gameCode,
    isMobileLogin: isMobileGameLaunch(),
  };
}

export async function fetchGameUrl({ apiBaseUrl, launchData, playerBalance }) {
  const response = await axios.post(
    `${apiBaseUrl}/gamelogin/gamestart`,
    {
      data: buildGameStartPayload({
        data: launchData,
        playerBalance,
      }),
    },
    { maxBodyLength: Infinity },
  );

  const gameUrl =
    typeof response?.data === "string"
      ? response.data
      : response?.data?.gameUrl || "";

  if (!gameUrl) {
    throw new Error("Game URL was not returned");
  }

  return gameUrl;
}
